<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基本信息">
        <el-descriptions :label-style="{width: '80px'}" :column="1" size="mini" border>
          <el-descriptions-item label="节点ID">
            <el-input :value="id" :disabled="true"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="节点名称">
            <el-input v-model="text"></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="监听">
        <BpmnMonitor v-model="form.monitor" @success="onInput" />
      </el-tab-pane>
      <el-tab-pane label="扩展">
        <BpmnExtend v-model="form.extend" @success="onInput" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BpmnMonitor from "./components/BpmnMonitor";
import BpmnExtend from "./components/BpmnExtend";
import FlowCommon from "../lib/FlowCommon";
export default {
  name: 'ConfluenceProperty',
  components: {BpmnExtend, BpmnMonitor},
  props: {
    nodeData: Object,
    lf: Object || String,
  },
  mounted() {
    this.onInit()
  },
  data() {
    return {
      id:"",
      text:"",
      form: FlowCommon.getNodeDefaultConfig('confluence').properties,
    }
  },
  watch:{
    text(n){
      const nodeData = this.$props.nodeData
      this.$props.lf.updateText(nodeData.id, n);
    }
  },
  methods: {
    onInit(){
      const { properties,text,id } = this.$props.nodeData
      this.id=id;
      this.text=(text||{}).value||"";
      if (properties) {
        this.$data.form = Object.assign({}, this.$data.form, properties)
      }
    },
    onInput(){
      var that=this;
      const nodeData = that.$props.nodeData
      nodeData.properties = that.$data.form
      that.$props.lf.setProperties(nodeData.id, that.$data.form);
    },
    onSubmit() {

    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/ConfluenceProperty.vue